<div class="footer_container">
  <div nxLayout="grid maxwidth">
    <div nxRow>
      <nx-footer class="footer-medium">
        <nx-footer-copyright>
          <p nxCopytext="medium" class="nx-font-weight-semibold">
            &copy; Allianz {{ currentYear }}.
            {{ "FOOTER.ALL_RIGHTS_RESERVED" | translate }}
          </p>
        </nx-footer-copyright>

        <nx-footer-navigation>
          <nx-footer-link>
            <a
              (click)="togglePrivacyPrinciples()"
              nxCopytext="medium"
              style="cursor: pointer"
              >{{ "FOOTER.PRIVACY_PRINCIPAL" | translate }}</a
            >
          </nx-footer-link>

          <nx-footer-link>
            <a
              (click)="toggleTermsOfUse()"
              nxCopytext="medium"
              style="cursor: pointer"
              >{{ "FOOTER.TERMS" | translate }}</a
            >
          </nx-footer-link>

          @if (showItHelpdesk) {
            <nx-footer-link>
              <a
                (click)="toggleItHelpdesk()"
                nxCopytext="medium"
                style="cursor: pointer"
                >{{ "FOOTER.HELPDESK" | translate }}</a
              >
            </nx-footer-link>
          }
        </nx-footer-navigation>
      </nx-footer>
    </div>
  </div>
</div>
@if (showScrollButton) {
  <div
    class="to-top nx-hidden-m nx-hidden-l nx-hidden-xl nx-hidden-2xl nx-hidden-3xl"
    (click)="scrollToTop()"
    (keydown.enter)="scrollToTop()"
    tabindex="0"
    role="button"
  >
    <img src="assets/img/shared/scroll-top.png" />
  </div>
}
